import { render, staticRenderFns } from "./PairResultsData.vue?vue&type=template&id=7916f1c9&scoped=true"
import script from "./PairResultsData.vue?vue&type=script&lang=js"
export * from "./PairResultsData.vue?vue&type=script&lang=js"
import style0 from "./PairResultsData.vue?vue&type=style&index=0&id=7916f1c9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7916f1c9",
  null
  
)

export default component.exports